import React, { Component } from 'react'
import { withRouter } from 'react-router'
import Favicon from 'react-favicon'
import bowser from 'bowser'
import ReduxToastr from 'react-redux-toastr'
import log from 'loglevel'
import _ from 'lodash'

import config from '../../config'

import authorization from '../../services/authorization'
import translations from '../../services/translations'
import socket from '../../services/socket'

import Error from '../../scenes/Error'
import Login from '../../scenes/Login'
import Gnosus from '../../scenes/Gnosus'
import Dialog from '../../services/dialog'
import Loader from '../../services/loader'

import { sendMessage } from '../../services/socket/helpers'
import { SOCKET_ACTION_TYPE } from '../../services/socket/constants'

import DragLayer from '../../dnd/dragLayer'

import icon from '../../assets/favicon.ico'

const browser = bowser.getParser(typeof window !== 'undefined' ? window.navigator.userAgent : 'UA')

@withRouter
@socket // must be above translations
@translations
@authorization(Login)
export default class App extends Component {
    constructor(props) {
        super(props)

        this.state = {
            hasError: false,
        }
    }

    componentDidMount() {
        const { locale } = this.props

        if (locale) document.documentElement.setAttribute('lang', locale)

        this.outputToConsole(true)
        sendMessage(SOCKET_ACTION_TYPE.NEW_STACK_READY)

        const allowedCookies = localStorage.getItem('allowTheseCookies')
        const allowedCookiesArr = !_.isNil(allowedCookies) ? allowedCookies.split(',') : null
    }

    componentDidUpdate(prevProps) {
        const { locale } = this.props
        const prevLocale = prevProps?.locale

        if (locale && locale !== prevLocale) document.documentElement.setAttribute('lang', locale)
    }

    componentDidCatch(error, info) {
        this.setState({ hasError: true })

        log.error('Unexpected error')
        log.error(error)
        log.info(info)
    }

    onContextMenuHandler = (_e) => {
        _e.preventDefault()
    }

    outputToConsole = (small = false) => {
        const style = 'color: #bed02e; font-size: 16px; line-height: 16px'

        if (small) {
            console.log('%c   GGG   N   N   OOO    SSS   U   U   SSS   ', style) // eslint-disable-line no-console
            console.log('%c  G      NN  N  O   O  S      U   U  S      ', style) // eslint-disable-line no-console
            console.log('%c  G GGG  N N N  O   O   SSS   U   U   SSS   ', style) // eslint-disable-line no-console
            console.log('%c  G   G  N  NN  O   O      S  U   U      S  ', style) // eslint-disable-line no-console
            console.log('%c   GGG   N   N   OOO    SSS    UUU    SSS   ', style) // eslint-disable-line no-console
        } else {
            console.log('%c   GGGGG   N     N   OOOOO    SSSSS   U     U   SSSSS   ', style) // eslint-disable-line no-console
            console.log('%c  G        NN    N  O     O  S     S  U     U  S     S  ', style) // eslint-disable-line no-console
            console.log('%c  G        N N   N  O     O  S        U     U  S        ', style) // eslint-disable-line no-console
            console.log('%c  G  GGGG  N  N  N  O     O   SSSSS   U     U   SSSSS   ', style) // eslint-disable-line no-console
            console.log('%c  G     G  N   N N  O     O        S  U     U        S  ', style) // eslint-disable-line no-console
            console.log('%c  G     G  N    NN  O     O  S     S  U     U  S     S  ', style) // eslint-disable-line no-console
            console.log('%c   GGGGG   N     N   OOOOO    SSSSS    UUUUU    SSSSS   ', style) // eslint-disable-line no-console
        }
    }

    render() {
        const { hasError } = this.state

        if (hasError) return <Error />

        return (
            <div className={'application'} onContextMenu={this.onContextMenuHandler}>
                <Favicon url={icon} />
                <Gnosus />
                <Dialog />
                <ReduxToastr {...config.toastr.init} />
                {!browser.some(['Internet Explorer', 'Microsoft Edge']) ? <DragLayer /> : null}
                <Loader />
            </div>
        )
    }
}
